<template>
  <v-container class="px-0">
    <p class="mr-5 headline px-2">Manage Content</p>
    <p class="px-2 body-1 grey--text">Add and edit the content on Omentum. Editor access required.</p>

    <v-layout class="text-right" wrap>
      <v-flex xs12 sm9>
        <v-text-field
          v-model="$store.state.manageContentSearch"
          prepend-inner-icon="mdi-magnify"
          color="orange"
          label="Search"
          outlined
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm3>
        <v-btn right color="orange" dark large @click="deckDialog = true" class="ma-3">
          Add Deck
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card v-if="decks">
      <v-data-table
        :headers="headers"
        :items="decks"
        :multi-sort="true"
        :search="$store.state.manageContentSearch"
        class="display-1"
        :sort-by.sync="$store.state.manageContentSort"
        :sort-desc.sync="$store.state.manageContentSortDesc"


        disable-pagination

      >
      <template v-slot:item.public="{ item }">
          <v-icon color="grey" v-if="!item.public">mdi-checkbox-blank-circle-outline</v-icon>
          <v-icon color="blue lighten-1" v-if="item.public">mdi-checkbox-marked-circle</v-icon>
      </template>
      <!-- <template v-slot:item.tags="{ item }">
          <v-chip small v-for="(x,i) in item.tags" :key="i">
            {{x}}
          </v-chip>
      </template> -->
        <template v-slot:item.manage="{ item }">
          <v-btn icon @click="$router.push({name: 'ManageDeck', params: {id: item.id}})">
            <v-icon color="orange">mdi-pencil-outline</v-icon>
          </v-btn>
        </template>

      </v-data-table>
    </v-card>


    <v-dialog v-model="deckDialog" max-width="400">
      <v-card class="pa-3">
        <v-form>
          <div class="headline my-3">Create Deck</div>
          <v-text-field label="Deck Name" v-model="newDeck.name"></v-text-field>
          <v-select label="Subject" :items="$store.state.contentProps.subjects" v-model="newDeck.subject"></v-select>
          <v-select label="Editors" :items="$store.state.editors" item-text="fullname" item-value="id" multiple v-model="newDeck.editors"></v-select>
          <v-text-field type="date" label="Lecture Date" v-model="newDeck.lectureDate"></v-text-field>
          <v-btn right disabled color="orange" v-if="newDeck.subject == null || newDeck.name == null">Create Deck</v-btn>
          <v-btn right dark color="orange" v-if="!(newDeck.subject == null || newDeck.name == null)" @click="createNewDeck()">Create Deck</v-btn>

        </v-form>
      </v-card>
    </v-dialog>
  <v-progress-circular v-if="loading" class="center-element" large indeterminate :size="90" :width="15" color="orange"></v-progress-circular>
  </v-container>

</template>

<script>
import Obj from '@/objects'
import _ from 'underscore'
import moment from 'moment'
import firebase from 'firebase'
import db from '@/fb'

export default {
  name: 'ManageContent',
  data() {
    return {
      decks: null,
      loading: false,
      newDeck: null,
      deckDialog: false,
      search: null,
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Subject', value: 'subject'},
        {text: 'Lecture Date', value: 'lectureDate'},
        {text: '# of Cards', value: 'deckLength'},
        {text: 'Published', value: 'public'},
        // {text: 'Tags', value: 'tags'},
        {text: 'Manage', value: 'manage'}
      ]

    }
  },
  computed: {


  },
  mounted() {
    this.newDeck = Obj.createNewDeck()
    this.getDecks()

  },
  methods: {
    getDecks() {
      //set parameters for user id and collection
      let uid = firebase.auth().currentUser.uid
      let collection = firebase.firestore().collection('decks')

      if (uid == "HSt6S2N9qHaG4sR2Uy6pYTMng123") {
        collection.get().then(snapshot => {
          this.decks = [] //clear existing decks
          snapshot.forEach(doc => {
            let deck = doc.data()
            deck.id = doc.id
            this.decks.push(deck)
          })
        })

      }
      else {
        //query based on editor access
        collection.where('editors', 'array-contains', uid)
        .get().then(snapshot => {
          this.decks = [] //clear existing decks
          snapshot.forEach(doc => {
            let deck = doc.data()
            deck.id = doc.id
            this.decks.push(deck)
          })
        })

      }

    },
    createNewDeck() {
      let doc = firebase.firestore().collection('decks').doc()
      doc.set(this.newDeck).then(result => {
        console.log(doc.id)
        this.newDeck = Obj.createNewDeck()
        this.deckDialog = false
        this.$router.push({name: 'ManageDeck', params: {id: doc.id}})
      })
    },
  }
}
</script>

<style>
.center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
